/* Duendes Air — carrusel "¿Qué hace diferente…" : cross-fade automático,
   una razón a la vez (~4.5s), dots clickeables, swipe manual, pausa al hover/tocar. */
(function () {
  if (window.__airViva) return; window.__airViva = 1;
  function boot() {
    [].forEach.call(document.querySelectorAll('[data-air-viva]'), init);
  }
  function init(root) {
    var slides = [].slice.call(root.querySelectorAll('.air-viva-slide'));
    var dots = [].slice.call(root.querySelectorAll('.air-viva-dot'));
    if (slides.length < 2) return;
    var i = 0, timer = null, paused = false;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    function next() { show(i + 1); }
    function start() { stop(); timer = setInterval(function () { if (!paused) next(); }, 4500); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); start(); }); });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    // swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; paused = true; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : show(i - 1); }
      x0 = null; paused = false; start();
    }, { passive: true });
    show(0);
    start();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
